import axios from "axios";

import { config } from "../environment/config";

export const client = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});
